<script setup>
// Painel da direita: muda conforme a seleção (e-mail, linha, coluna ou o
// tipo do elemento). Cada campo grava num grupo próprio de desfazer.
import { computed, inject } from 'vue';
import { useI18n } from 'vue-i18n';
import DocumentProps from './props/DocumentProps.vue';
import RowProps from './props/RowProps.vue';
import ColumnProps from './props/ColumnProps.vue';
import TextProps from './props/TextProps.vue';
import ImageProps from './props/ImageProps.vue';
import ButtonProps from './props/ButtonProps.vue';
import DividerProps from './props/DividerProps.vue';
import SpacerProps from './props/SpacerProps.vue';
import HtmlProps from './props/HtmlProps.vue';
import VideoProps from './props/VideoProps.vue';
import SocialProps from './props/SocialProps.vue';
import ProductProps from './props/ProductProps.vue';

const ed = inject('emailEditor');
const { t } = useI18n();
const BY_TYPE = {
  heading: TextProps,
  text: TextProps,
  image: ImageProps,
  logo: ImageProps,
  button: ButtonProps,
  divider: DividerProps,
  spacer: SpacerProps,
  html: HtmlProps,
  video: VideoProps,
  social: SocialProps,
  product: ProductProps,
};

const sel = computed(() => ed.selected.value);
const node = computed(() => (sel.value ? sel.value[sel.value.kind] : null));
const view = computed(() => {
  if (!sel.value)
    return {
      component: DocumentProps,
      title: t('EMAIL_TEMPLATES.EDITOR.NODE.document'),
    };
  if (sel.value.kind === 'row')
    return {
      component: RowProps,
      title: t(
        sel.value.row.role === 'footer'
          ? 'EMAIL_TEMPLATES.EDITOR.NODE.footer'
          : 'EMAIL_TEMPLATES.EDITOR.NODE.row'
      ),
    };
  if (sel.value.kind === 'column')
    return {
      component: ColumnProps,
      title: t('EMAIL_TEMPLATES.EDITOR.NODE.column'),
    };
  return {
    component: BY_TYPE[sel.value.element.type],
    title: t(`EMAIL_TEMPLATES.EDITOR.ELEMENT.${sel.value.element.type}`),
  };
});
const onUpdate = (patch, key) =>
  ed.update(node.value.id, patch, { group: `${node.value.id}:${key}` });
</script>

<template>
  <div class="flex h-full flex-col">
    <div
      class="border-b border-n-weak px-4 py-3 text-sm font-semibold text-n-slate-12"
    >
      {{ view.title }}
    </div>
    <div class="min-h-0 flex-1 overflow-y-auto p-4">
      <component
        :is="view.component"
        :key="node?.id || 'document'"
        :node="node"
        :selection="sel"
        @update="onUpdate"
      />
    </div>
  </div>
</template>
